import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from '../../../icon/icon.component';
import { LoadingSpinnerComponent } from '../../../loading/loading-spinner/loading-spinner.component';
import { BaseProgressComponent } from '../base-progress.component';

@Component({
  selector: 'nrc-translation-progress',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './translation-progress.component.html',
  styleUrl: './translation-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TranslationProgressComponent extends BaseProgressComponent {
  public readonly currentStep = computed(() => this.progressSignal()?.processed || 0);

  public readonly totalSteps = computed(() => this.progressSignal()?.total || 0);
}
